export default __webpack_public_path__ + "static/redbubble-icon-66bbf5c04f016d80d007b95a950fbd1e.png";